<template>
  <b-col sm="3">
    <h5
      class="font-weight-bolder"
    >
      {{ containsData ? formatValue(data) : '' }} {{ symbol }}
      <span class="text-sm text-secondary font-weight-normal">{{ text }}</span>
    </h5>
  </b-col>
</template>

<script>
export default {
  props: {
    data: {
      type: Number,
      default: 0,
    },
    containsData: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    text: {
      type: String,
    },
    symbol: {
      type: String,
      default: '',
    },
  },
  setup() {
    const formatValue = amount => {
      const amt = Number(amount)
      // eslint-disable-next-line no-mixed-operators
      return amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 }) || '0'
    }
    return {
      formatValue,
    }
  },
}
</script>

<style>

</style>
